import apiClient from './ApiClient';

export class FileRepository {
  constructor(client) {
    this.client = client;
    this.basePath = '/api';
  }

  /**
   * Upload an image file
   * @param {File} file 
   * @param {string} folder 
   * @returns {Promise<any>} 
   */
  async upload(file, folder = 'gallery') {
  const formData = new FormData();
  
  // 1. Ensure the key 'file' matches the Swagger 'Name' field exactly.
  formData.append('file', file);

  try {
    // 2. We use the apiClient but pass the formData directly.
    // Ensure your ApiClient fix from the previous step is applied!
    const response = await this.client.post(
      `/api/storage/upload?folder=${folder}`, 
      formData
    );

    // 3. Return the URL from the response data
    // Usually ASP.NET returns something like { data: "url" } or { path: "url" }
    return response?.data || response?.url || response;
  } catch (error) {
    console.error("Repo Upload Error:", error.data || error.message);
    throw error;
  }
}
};

export default new FileRepository(apiClient);